const setBreadcrumbsMultipleLevelsArray = (state, payload) => {
  state.breadcrumbsMultipleLevelsArray = payload
}

export default {
  setBreadcrumbsMultipleLevelsArray,
}
